import { render, staticRenderFns } from "./BookingRedirect.vue?vue&type=template&id=db4a0020&scoped=true"
import script from "./BookingRedirect.vue?vue&type=script&lang=js"
export * from "./BookingRedirect.vue?vue&type=script&lang=js"
import style0 from "./BookingRedirect.vue?vue&type=style&index=0&id=db4a0020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4a0020",
  null
  
)

export default component.exports